import {OrderService} from '../../services/order.service';
import {AfterContentChecked, Component} from '@angular/core';
import {OnInit, OnDestroy, Input} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {OrderState} from '../../services/OrderState';
import {item} from '../../item';
import {Utility} from '../../utility';
import {ItonicsAuthService} from '../../services/itonicsAuth.service';
import * as moment from 'moment-timezone';
import { SettingService } from '../../services/setting.service';
import { Settings } from '../../interfaces/setting';

@Component({
  selector: 'app-order-placement',
  templateUrl: './order-placement.component.html',
  styleUrls: ['./order-placement.component.scss']
})
export class OrderPlacementComponent implements OnInit, AfterContentChecked {
  loaded: Boolean = true;
  items: any[];
  total: number;
  private subscription: Subscription;
  public extraTotal = 0;
  public netTotal = 0;
  public loggedId: string;
  public settingsData: any = [];
  now = new Date();
  public currentTime = moment.tz(this.now, 'Asia/Kathmandu').format('HH:mm:ss');
  timeRightNow = moment(this.currentTime, 'h:mma');
  endTime = moment('11:30am', 'h:mma');
  public canEdit = this.timeRightNow.isBefore(this.endTime);

  constructor(private _orderService: OrderService, public itonicsAuthService: ItonicsAuthService, private settingService: SettingService,) {
    this.loggedId = itonicsAuthService.getCurrentUser()['username'];
  }

  ngOnInit() {
    this.subscription = this._orderService.orderState.subscribe((state: OrderState) => {
      this.items = state.items;
    });
  }

  ngAfterContentChecked() {
    this.netTotal = 0;
    this.extraTotal = 0;

    let settingdata;
    this.settingService.settings.subscribe((settings: Settings) => {
      settingdata = settings;
      if (settingdata.length == 0) {
        // console.log('no data')
        return
      }
      settingdata.forEach(element => {
        this.settingsData[element.alias] = element.value;
      });

    this.items.map((obj) => {
      if (this.loggedId === obj.userId) {
        this.netTotal += obj.discountPrice;
      }
    });

    if (this.netTotal > this.settingsData.lunchamount) {
      this.extraTotal += this.netTotal - this.settingsData.lunchamount;
    }

    })
  }

  removeQuickOrder(_item: item) {
    if (confirm('Are you sure to delete ' + _item.title)) {
      this._orderService.removeQuickOrder(_item.id).subscribe((something) => {
      });
    }
  }

  OnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/order-placement/order-placement.component.ts